module.exports = __webpack_public_path__ + "img/about-basketball-desktop.1e50bff7.png";